import React from "react";

import { useStockPageOptional } from "../lib/StockPage";
import withQuoteData from "./withQuoteData";

const COMPANY_INFO_FIELDS = [
  "ceo",
  "sector",
  "website",
  "description",
  "share_amount",
  "capitalization"
];

function hasCompanyInfo(stockEntity) {
  return COMPANY_INFO_FIELDS.some(field => {
    const value = stockEntity[field];
    return value !== null && value !== undefined && value !== "";
  });
}

/**
 * Injects `stockBasicInfo` (with quote-based capitalization).
 * Prefers an explicit `stock` StockPayload prop; otherwise reads from StockPageProvider.
 */
export default function withStockBasicInfo(WrappedComponent) {
  @withQuoteData(false, props => props.stock?.stock?.id)
  class WithStockBasicInfo extends React.Component {
    getBasicInfo() {
      const { stock, quoteData } = this.props;
      const stockEntity = stock?.stock;

      if (!stockEntity || !hasCompanyInfo(stockEntity)) {
        return {};
      }

      const { close } = quoteData || {};
      const quoteCapitalization = Math.round(stockEntity.share_amount * close);

      return {
        fullname: stockEntity.name,
        ceo: stockEntity.ceo,
        sector: stockEntity.sector,
        market: stockEntity.market,
        indexes: (stockEntity.index_tickers || []).join(", "),
        website: stockEntity.website,
        description: stockEntity.description,
        share_amount: stockEntity.share_amount,
        capitalization: isNaN(quoteCapitalization)
          ? stockEntity.capitalization
          : quoteCapitalization
      };
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          stockBasicInfo={this.getBasicInfo()}
        />
      );
    }
  }

  function WithStockBasicInfoFromContext(props) {
    const stockPage = useStockPageOptional();
    const stock = props.stock ?? stockPage?.stock?.data ?? null;

    return <WithStockBasicInfo {...props} stock={stock} />;
  }

  return WithStockBasicInfoFromContext;
}
